module.exports = __webpack_public_path__ + "static/media/manu.bc1e0f4f.jpg";